const {h, render, Component} = require('preact')
const TabsContainer = require('../common/tabs')
const ClaimsContainer = require('../gplus/claims')
const FaqsContainer = require('../faq/faqs')
const Banner = require ('../../views/common/banner.js')
const MarketingBanner = require ('../../views/common/marketing-banner.js');
const LoggedInOtherIssues = require('../main/logged_in_other_issues');

class ClaimsLandingPage extends Component {
  constructor(props) {
    super(props);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  hideHeaderBannerIfPresent() {
    var headerBanner = document.getElementById("header-banner")
    if (headerBanner)
      headerBanner.setAttribute("style", "display:none")
  }

  render() {
    this.hideHeaderBannerIfPresent()
    return (
        <section className="main row cs_support_header" id="contact-us-body-content">
          <div className="twelve columns">
            <section className="module">
              <div className="module-body contact-us">
                <div className="row">
                  <div className="twelve columns">
                    <div className="page_header">
                      <MarketingBanner />
                      <Banner />
                      <h2 className="landing-page-header">{I18n.t('js.modules.web_2018.customer_support')}</h2>
                    </div>
                    <div className="choose-your-order">
                      <h3>{I18n.t('js.modules.web_2018.need_help_with_a_groupon')}</h3>
                      <span className="need_help_with_a_groupon">{I18n.t('js.modules.web_2018.choose_your_order_to_proceed')}</span>
                    </div>
                    <TabsContainer page="my-gplus"/>
                    <ClaimsContainer />
                    <FaqsContainer />
                    { this.configFromDom.fbOrderContactsEnabled  && <LoggedInOtherIssues /> }
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
    )
  }
}

module.exports = ClaimsLandingPage
